import { route } from 'frontend/inertia/routes'

export const learnSessionsPath = {
  // mirrors frontend_learn_sessions
  index: route('/lernen'),
  // mirrors frontend_learn_sessions
  create: route('/lernen'),
  // mirrors frontend_learn_session
  show: route('/lernen/:subject_area_id/s/:identifier'),
  // mirrors append_block_frontend_learn_session
  appendBlock: route('/lernen/s/:identifier/append_block'),
  // mirrors report_progress_frontend_learn_session
  reportProgress: route('/lernen/s/:identifier/report_progress'),
  // mirrors frontend_learn_session_block_stream
  blockStream: route('/lernen/s/:learn_session_identifier/blocks/:block_id/stream'),
  // mirrors frontend_learn_session_block_share
  blockShare: route('/lernen/s/:learn_session_identifier/blocks/:block_id/share'),
  // mirrors frontend_transcript_uploads
  transcriptUploads: route('/lernen/uploads'),
}

export const customPlaylistsPath = {
  // mirrors frontend_custom_playlists
  index: route('/lernen/lernplaene'),
  // mirrors frontend_custom_playlists
  create: route('/lernen/lernplaene'),
  // mirrors add_video_frontend_custom_playlist
  addVideo: route('/lernen/lernplaene/:id/add_video'),
  // mirrors remove_video_frontend_custom_playlist
  removeVideo: route('/lernen/lernplaene/:id/remove_video'),
}
